import React from 'react';

const KenticoTable = ({ data, style, cutOnWidth }) => {
  const clearedData = data ? data.filter(value => value) : [];

  const headerValue = clearedData[0] ? clearedData[0] : [];
  const tableHeader = cutOnWidth
    ? headerValue.slice(0, cutOnWidth)
    : headerValue;

  const bodyValue = clearedData
    ? clearedData.filter(value => value !== headerValue)
    : [];
  const tableBody = cutOnWidth
    ? bodyValue.map(value => value.slice(0, cutOnWidth))
    : bodyValue;

  return (
    <>
      <table className={style}>
        {tableHeader ? (
          <thead>
            <tr>
              {tableHeader.map((cell, index) => {
                return <th key={index}>{cell}</th>;
              })}
            </tr>
          </thead>
        ) : null}
        {tableBody ? (
          <tbody>
            {tableBody.map((row, i) => {
              return row.join('') !== '' ? (
                <tr key={i}>
                  {row.map((cell, j) => {
                    return <td key={j}>{cell}</td>;
                  })}
                </tr>
              ) : null;
            })}
          </tbody>
        ) : null}
      </table>
    </>
  );
};

export default KenticoTable;



// WEBPACK FOOTER //
// ./src/common/components/KenticoTable/KenticoTable.js